export default "__VITE_ASSET__CcXG7EJL__"